import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { Drawer, DrawerBody, DrawerFooter, DrawerHeader, DrawerOverlay, DrawerContent, DrawerCloseButton } from '@chakra-ui/react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleDrawer, toggleDrawerContent } from '../../actions/ui';
const CMXDrawer = ()=>{
    // isDrawerOpen used for show or not the Drawer
    const { isDrawerOpen, drawerSize } = useSelector((state)=>{
        if (state.providerDetails.isDrawerOpen) {
            return {
                isDrawerOpen: state.providerDetails.isDrawerOpen,
                drawerSize: 'lg'
            };
        }
        if (state.coderNotes.isDrawerOpen) {
            return {
                isDrawerOpen: state.coderNotes.isDrawerOpen,
                drawerSize: 'lg'
            };
        }
        if (state?.createCase?.isDrawerOpen) {
            return {
                isDrawerOpen: state.createCase.isDrawerOpen,
                drawerSize: 'md'
            };
        } else {
            return {
                isDrawerOpen: state.patientTimeline.isDrawerOpen,
                drawerSize: 'xl'
            };
        }
    });
    const dispatch = useDispatch();
    // popstate event is used here for close the Drawer when users clicks a back button
    useEffect(()=>{
        window.addEventListener('popstate', (ev)=>{
            if (isDrawerOpen) {
                dispatch(toggleDrawer(false));
                dispatch(toggleDrawerContent(false));
            }
        });
    });
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs(Drawer, {
            isOpen: isDrawerOpen,
            size: drawerSize,
            blockScrollOnMount: false,
            placement: "right",
            onClose: ()=>{
                dispatch(toggleDrawer(false));
                dispatch(toggleDrawerContent(false));
            },
            children: [
                /*#__PURE__*/ _jsx(DrawerOverlay, {
                    overflow: "scroll"
                }),
                /*#__PURE__*/ _jsxs(DrawerContent, {
                    children: [
                        /*#__PURE__*/ _jsx(DrawerCloseButton, {}),
                        /*#__PURE__*/ _jsx(DrawerHeader, {
                            id: "cmx-drawer-header"
                        }),
                        /*#__PURE__*/ _jsx(DrawerBody, {
                            id: "cmx-drawer-body"
                        }),
                        /*#__PURE__*/ _jsx(DrawerFooter, {
                            id: "cmx-drawer-footer"
                        })
                    ]
                })
            ]
        })
    });
};
CMXDrawer.displayName = 'CMXDrawer';
export { CMXDrawer };
